var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7257 6.47059C12.4453 5.84314 11.5547 5.84313 11.2743 6.47059L10.7173 7.71727L9.47059 8.2743C8.84314 8.55466 8.84314 9.44534 9.47059 9.7257L10.7173 10.2827L11.2743 11.5294C11.5547 12.1569 12.4453 12.1569 12.7257 11.5294L13.2827 10.2827L14.5294 9.7257C15.1569 9.44534 15.1569 8.55466 14.5294 8.2743L13.2827 7.71727L12.7257 6.47059Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4838 3.31373C17.2969 2.89542 16.7031 2.89542 16.5162 3.31373L16.1448 4.14485L15.3137 4.5162C14.8954 4.7031 14.8954 5.2969 15.3137 5.4838L16.1448 5.85515L16.5162 6.68627C16.7031 7.10458 17.2969 7.10458 17.4838 6.68627L17.8552 5.85515L18.6863 5.4838C19.1046 5.2969 19.1046 4.7031 18.6863 4.5162L17.8552 4.14485L17.4838 3.31373Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V19C16 20.6569 14.6569 22 13 22H11C9.34315 22 8 20.6569 8 19V16M12 2C7.85786 2 4.5 5.35867 4.5 9.5018C4.5 12.2785 6.00824 14.7029 8.25 16M19.5 9.5018C19.5 12.2785 17.9918 14.7029 15.75 16",
    stroke: "#FFD43C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16L8 16M16 19L8 19",
    stroke: "#FFD43C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBulbIcon);
export default __webpack_public_path__ + "static/media/lightBulbIcon.592a8321d000452d8d17ff674da18fea.svg";
export { ForwardRef as ReactComponent };